module.exports = __webpack_public_path__ + "img/smpo_150x150.bc44b018.png";